import axios from 'axios';

export const projectsAxios = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URI}/projects`,
});